<template>
  <el-card
    class="card-container"
    shadow="never"
  >
    <CardHeader
      slot="header"
      title="Cấu hình dữ liệu"
      :total="total"
      :all-configs="allConfigs"
      @create="handleCreate"
      @refresh="handleRefresh"
    />
    <CardFilter
      :type="type"
      @search="handleSearch"
    />
    <CardList
      :data="data"
      :loading="loading"
      @edit="handleUpdate"
      @delete="handleDelete"
      @config="handleConfig"
      @publish="handlePublish"
    />
    <el-row
      type="flex"
      align="middle"
      justify="end"
      class="mt-l"
    >
      <el-pagination
        background
        :current-page="page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        :total="total"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleChangePageSize"
        @current-change="handleChangePage"
      />
    </el-row>
    <FormPopup
      v-if="formVisible"
      :visible="formVisible"
      :item="selectedItem"
      :all-configs="allConfigs"
      :org-id="selectedOrg.id"
      @close="formVisible = false"
      @reload="fetchData"
    />
  </el-card>
</template>

<script>
import { mapGetters } from "vuex";
import CardHeader from "./components/CardHeader.vue";
import CardFilter from "./components/CardFilter.vue";
import CardList from "./components/CardList.vue";
import FormPopup from "./popups/ObjectForm.vue";

import { notification } from "@/utils/common";
import configServices from "@/services/config";

export default {
  name: "Config",
  components: {
    CardHeader,
    CardFilter,
    CardList,
    FormPopup,
  },
  data() {
    return {
      loading: false,
      page: 1,
      pageSize: 10,
      total: 0,
      data: [],
      selectedItem: null,
      formVisible: false,
      searchText: "",
      type: "",
      allConfigs: []
    };
  },
  computed: {
    ...mapGetters("organization", ["selectedOrg"]),
    params() {
      const _params = {
        offset: (this.page - 1) * this.pageSize,
        limit: this.pageSize,
        locale: "vi",
        sort: "-created",
        filters: {}
      };
      if (this.searchText) {
        _params.filters['extra.name'] = { $regex: this.searchText }
      }
      if (this.selectedOrg) {
        _params.filters['extra.organization_id'] = this.selectedOrg.id
      }
      if (this.type) {
        _params.filters['type'] = this.type
      }
      return _params;
    },
    allParams() {
      const _params = {
        offset: 0,
        limit: 999,
        filters: {}
      };
      if (this.selectedOrg) {
        _params.filters['extra.organization_id'] = this.selectedOrg.id
      }
      return _params;
    },
  },
  watch: {
    selectedOrg: {
      handler() {
        this.fetchData()
      },
      deep: true,
      immediate: true,
    },
  },
  beforeMount() {
    this.fetchData();
  },
  methods: {
    fetchData() {
      if (!this.selectedOrg) {
        return
      }
      Promise.all([
        this.getAllConfigs(),
        this.listConfigs(),
      ])
    },
    getAllConfigs() {
      configServices.list(this.allParams)
        .then((response) => {
          this.allConfigs = response.items;
        })
        .catch(() => {
          this.allConfigs = [];
        })
    },
    listConfigs() {
      this.loading = true;
      configServices
        .list(this.params)
        .then((response) => {
          this.data = response.items.map((i, index) => ({
            ...i,
            stt: index + 1 + this.pageSize * (this.page - 1),
          }));
          this.total = response.meta.total;
          this.loading = false;
        })
        .catch(() => {
          this.data = [];
          this.loading = false;
        });
    },
    handleCreate() {
      this.selectedItem = { type: this.type };
      this.formVisible = true;
    },
    handleUpdate(item) {
      this.selectedItem = item;
      this.formVisible = true;
    },
    handleConfig(item) {
      this.$router.push({
        name: "ConfigDetail",
        params: { id: item.id },
      });
    },
    handleDelete(item) {
      this.$confirm(`Bạn có chắc chắn muốn xoá không? Nếu xoá hãy đảm bảo cấu trúc dữ liệu k bị ảnh hưởng`, "Xác nhận", {
        confirmButtonText: "Xoá",
        cancelButtonText: "Huỷ",
        type: "warning",
      }).then(() => {
        configServices
          .remove(item)
          .then(() => {
            if (this.data.length === 1 && this.page > 1) {
              this.page = this.page - 1;
            }
            this.fetchData();
            notification(this, "success", "delete", `đối tượng`);
          })
          .catch(() => {
            notification(this, "error", "delete", "đối tượng");
          });
      });
    },
    handleSearch(payload) {
      this.page = 1;
      this.searchText = payload.searchText;
      this.type = payload.type;
      this.listConfigs();
    },
    handleRefresh() {
      this.selectedItem = null;
      this.page = 1;
      this.searchText = "";
      this.fetchData();
    },
    handleChangePage(page) {
      this.page = page;
      this.listConfigs();
    },
    handleChangePageSize(size) {
      this.page = 1;
      this.pageSize = size;
      this.listConfigs();
    },
    handlePublish(item, value) {
      const payload = {
        ...item,
        extra: {
          ...item.extra,
          is_publish: value,
        },
      };
      configServices
        .update(payload)
        .then(async () => {
          this.fetchData();
        })
        .catch(() => {
          notification(this, "error", "update", "đối tượng");
        });
    },
  },
};
</script>

<style lang="scss" scoped></style>
